export default "__VITE_ASSET__eCnw2_UP__"